// FastAPI returns `detail` as a string for HTTPException but as an array of
// objects for 422 validation errors. Rendering that array in a toast crashes
// React ("Objects are not valid as a React child") and white-screens the app.
// Always run API error details through this before showing them.

const FIELD_LABELS = {
  email: 'Client email',
  phone_number: 'Phone number',
  client_name: 'Client name',
  pet_name: 'Pet name',
  pet_type: 'Pet type',
  weight_kg: 'Weight',
  sex: 'Sex',
  breed: 'Breed',
  address: 'Address',
  postcode: 'Postcode',
  age_years: 'Age (years)',
  age_months: 'Age (months)',
  microchip_number: 'Microchip number',
  estimated_pickup_date: 'Collection date',
  new_password: 'New password',
  current_password: 'Current password',
};

const formatOne = (item) => {
  if (typeof item === 'string') return item;
  if (!item || typeof item !== 'object') return '';
  const loc = Array.isArray(item.loc) ? item.loc : [];
  const field = [...loc].reverse().find((p) => typeof p === 'string' && p !== 'body');
  const label = field ? FIELD_LABELS[field] || field.replace(/_/g, ' ') : '';
  let msg = typeof item.msg === 'string' ? item.msg : 'is invalid';
  msg = msg.replace(/^Value error,\s*/i, '');
  if (/valid email address/i.test(msg)) msg = 'must be a valid email address (e.g. name@example.com)';
  return label ? `${label}: ${msg}` : msg;
};

export const getErrorMessage = (detail, fallback = 'Something went wrong. Please try again.') => {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map(formatOne).filter(Boolean);
    return parts.length ? parts.join(' · ') : fallback;
  }
  if (typeof detail === 'object') return formatOne(detail) || detail.message || fallback;
  return String(detail);
};
